import { cloneDeep, isEmpty } from 'lodash';
import { reverseFormatFormDate, calculateAge } from '@general/js/utils';
import { CoverComposition, NeedsAnalysisEligibility } from '@general/js/enums';
import { mapPerson } from '@general/js/utils/JoinNow';
import { formatQuoteLHCABD, mapVeteranCard } from './PersonUtils';

const mapPolicyHolderPayload = (mainPolicyHolderObj, captureInformationReferenceData, changeCoverData, caiData, convertedCoverType, hospitalSituation) => {
  const policyHolderObj = cloneDeep(caiData.policyHolderStep);
  const policyHolderVeteranCard = caiData.policyHolderStep.veteranCard;
  policyHolderObj.sex = caiData.policyHolderStep.gender;
  const noLongerEligibleForVeteran =
    policyHolderObj.veteranCard.haveVeteranCard &&
    (changeCoverData.step1.eligibility === NeedsAnalysisEligibility.WORK_CONNECTION || changeCoverData.step1.eligibility === NeedsAnalysisEligibility.RELATED);

  const mappedPolicyHolder = mapPerson(
    mapVeteranCard(policyHolderObj, policyHolderVeteranCard, noLongerEligibleForVeteran),
    captureInformationReferenceData,
    { coverType: convertedCoverType },
    true,
  );

  mappedPolicyHolder.covered = changeCoverData.step2.composition !== CoverComposition.CHILDREN_ONLY;
  mappedPolicyHolder.age = calculateAge(reverseFormatFormDate(caiData.policyHolderStep.DOB));
  // TODO: May need to be updated based on which date should be used as cover start date

  mappedPolicyHolder.previousFunds = [];

  const policyHolderLHCABD = formatQuoteLHCABD(policyHolderObj, hospitalSituation, mainPolicyHolderObj.lhcOverrule !== null);

  mappedPolicyHolder.lifetimeHealthCoverOverrule = !isEmpty(policyHolderLHCABD?.lhc) ? { ...policyHolderLHCABD?.lhc } : null;
  mappedPolicyHolder.ageBasedDiscount = !isEmpty(policyHolderLHCABD?.abd) ? { ...policyHolderLHCABD?.abd } : null;

  return mappedPolicyHolder;
};

export default mapPolicyHolderPayload;
